// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3877":"fe336940f98fdfab","6676":"1906550b41980f86","7584":"a5f0c83ca3a862b0","8245":"355127b2a0886a5d"}[chunkId] + ".css";
};